




























































import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { vxm } from '../store.vuex';

import SectionTitle from '@/components/Commons/SectionTitle.vue';
import ReferralIncentive from './MyReferrals/ReferralIncentive.vue';
import ReferralSearch from './MyReferrals/ReferralSearch.vue';
import ReferralStatusWiseCount from './MyReferrals/ReferralStatusWiseCount.vue';
import CandidateCard from './MyReferrals/CandidateCard.vue';
import ReferralEmptyPage from './MyReferrals/ReferralEmptyPage.vue';
import ReferCompany from './MyReferrals/ReferCompany.vue';
import ReferralCard from './MyReferrals/ReferralCard.vue';
import JobReferralCard from './MyReferrals/JobReferralCard.vue';
import { REFERRAL_TYPE } from './MyReferrals/constants';
declare var window: any;
@Component({
  name: 'MyReferralsList',
  components: {
    ReferralIncentive,
    ReferralSearch,
    ReferralStatusWiseCount,
    CandidateCard,
    ReferralEmptyPage,
    ReferCompany,
    ReferralCard,
    JobReferralCard,
    SectionTitle,
  },
})
export default class MyReferralsList extends Vue {
  private referralStats = vxm.referrals.getReferralStats;
  private promoteReferral = vxm.referrals.getReferralSuccess;
  private sorting: boolean = true;
  private searchText: string = '';
  private referralSearch = this.lodash.debounce((searchText) => {
    vxm.referrals.fetchReferralStats({
      searchString: searchText,
      ascending: this.sorting,
    });
  }, 500);

  onReferralSearch(searchText) {
    this.searchText = searchText;
    this.referralSearch(searchText);
  }

  onReferralSorting() {
    this.sorting = !this.sorting;
    vxm.referrals.fetchReferralStats({
      searchString: this.searchText,
      ascending: this.sorting,
    });
  }

  get canShowPromoteTab() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      const promoteTab = vxm.configs.slideMenuSubSections(
        'MY_REFERRALS',
        'PROMOTE_APP_TAB',
      );
      return promoteTab && !this.disableMyReferrals ? true : false;
    }
    return !vxm.jobs.BrandingInfo.DISABLE_MYREFERRALS_PROMOTE_TAB;
  }
  get disableMyReferrals() {
    return vxm.configs.getGlobalConfigValue('DISABLE_MYREFERRALS_PROMOTE_TAB');
  }
  get appstoreUrl() {
    return window.WorkLLama.workllamaIosAppUrl;
  }
  get playstoreUrl() {
    return window.WorkLLama.workllamaAndroidAppUrl;
  }
  get canShowReferralIncentive() {
    return vxm.configs.getGlobalConfigValue('SHOW_REFERRAL_INCENTIVE');
  }
  get canShowZeroIncentive() {
    const total = this.getFixedAmount() + this.getVariableAmount();
    return (total > 0) || vxm.configs.getGlobalConfigValue('ZERO_INCENTIVE_ENABLED');
  }
  get hasReferrals() {
    if (
      this.referralStats &&
      this.referralStats.referrals &&
      (this.getAppReferrals() ||
        this.getFriendReferrals() ||
        this.getJobReferrals())
    )
      return this.referralStats.referrals.length || this.searchText;
    else return false;
  }
  get promoteCompany() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      const promoteCompany = vxm.configs.slideMenuSubSections(
        'MY_REFERRALS',
        'PROMOTE_APP_TAB',
      );
      if (promoteCompany && promoteCompany.displayName) {
        return promoteCompany.displayName;
      } else {
        return 'Promote App';
      }
    }
    return this.$t('myreferrals.promotecompany', {
      companyName: vxm.configs.getGlobalConfigValue(
        'WL_CANDIDATE_PORTAL_APPLICATION_NAME',
      ),
    });
  }
  get header() {
    if (this.appstoreUrl || this.playstoreUrl) {
      return this.$t('myreferrals.header', {
        companyName: vxm.configs.getGlobalConfigValue(
          'WL_CANDIDATE_PORTAL_APPLICATION_NAME',
        ),
      });
    }
    return this.$t('myreferrals.myreferrals');
  }
  getFixedAmount() {
    return Number(this.referralStats.totalFixedPoints);
  }
  getVariableAmount() {
    return Number(this.referralStats.totalVariablePoints);
  }
  getAppReferrals() {
    return (
      (this.appstoreUrl || this.playstoreUrl) &&
      this.referralStats.referrals.find(
        (ref) => ref.refType === REFERRAL_TYPE.APP_REFERRAL,
      )
    );
  }
  getFriendReferrals() {
    return this.referralStats.referrals.find(
      (ref) => ref.refType === REFERRAL_TYPE.FRIEND_REFERRAL,
    );
  }
  getJobReferrals() {
    return this.referralStats.referrals.filter(
      (ref) => ref.refType === REFERRAL_TYPE.JOB_REFERRAL,
    );
  }
  getShareCode() {
    const friendReferrals = this.getFriendReferrals();
    return friendReferrals ? friendReferrals.referralCode : '';
  }
  mounted() {
    console.log(this.referralStats);
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      const selectedReferral = vxm.referrals.getReferralStats.referrals.find(
        (ref) => ref.referralCode === collapseId,
      );
      if (selectedReferral && isJustShown) {
        if (selectedReferral.refType === REFERRAL_TYPE.APP_REFERRAL) {
          vxm.referrals.fetchAppReferralDetails({ referralCode: collapseId });
          return;
        } else {
          vxm.referrals.fetchReferralDetails({ referralCode: collapseId });
        }
      }
    });
    vxm.referrals.fetchReferralStats({
      searchString: '',
      ascending: true,
    });
    vxm.referrals.fetchPromotereferral();
  }
}
